import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {GetAllDepartments} from "../../../../../reduxToolkit/DocumentPanel/DocumentPanelApi";
import {DeleteItemsApi} from "../../../../../reduxToolkit/Commons/CommonsApi";
import {useNavigate} from "react-router-dom";
import {TABLES} from "../../../../../Apis/Tables";

const UserDocPanelApp = () =>{
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [addDocumentModal, setAddDocumentModal] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [selectDocForDelete, setSelectDocForDelete] = useState([]);
    const [deleteDocShow, setDeleteDocShow] = useState(false);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    // The panel only handles employee documents, so the step is fixed for the document modal
    const activeStep = 0;
    const [modified, setModified] = useState(false);
    const [action, setAction] = useState(null);
    const [item, setItem] = useState(null);

    const resetAllCheckboxes = () => {
        const checkboxes = document.querySelectorAll('.checkbox');
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });
    };

    useEffect(() => {
        resetAllCheckboxes();
        setSelectDocForDelete([]);
        setIsAllChecked(false);
        dispatch(GetAllDepartments());
    }, []);

    const deleteSelectedDocuments = (deleteItem) => {
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName: TABLES.EMPLOYEE_DOCUMENT_COMPANY, body })).then(
                ({
                     payload: {
                         data: { success },
                     },
                 }) => {
                    if (success === true) {
                        setModified(true);
                        setSelectDocForDelete([]);
                        setIsAllChecked(false);
                    }
                },
            );
        }
    };

    const handleAction = (item, action) => {
        setItem(item);
        setAction(action);
        setAddDocumentModal(true);
    }

    return {
        t,
        DEV,
        navigate,
        permission,
        activeStep,
        addDocumentModal,
        setAddDocumentModal,
        isAllChecked,
        setIsAllChecked,
        selectDocForDelete,
        deleteDocShow,
        setDeleteDocShow,
        setSelectDocForDelete,
        modified,
        setModified,
        action,
        setAction,
        item,
        setItem,
        deleteSelectedDocuments,
        handleAction
    }
}

export default UserDocPanelApp;
